import { call, put, select } from 'typed-redux-saga'
import type { PayloadAction } from '@reduxjs/toolkit'

import { logger } from 'APP/Lib/Datadog'
import { selectFeatures } from 'APP/Sagas/FeaturesSaga'
import { getNextTasks } from './api'
import { MEMBER_TASKS_STALE_TTL_MS } from './config'
import { selectMemberTasksRequestState } from './selectors'
import { memberTasks } from './slice'
import { FetchTasksTarget } from './types'

export function* fetchTasks(action: PayloadAction<FetchTasksTarget & { force?: boolean }>) {
  const { enableEpisodeNextTasks } = yield* select(selectFeatures)
  if (!enableEpisodeNextTasks) return

  // The global Today view is not wired up yet — only episode-scoped fetches run.
  if (action.payload.scope !== 'episode') return

  const { episodeId, force } = action.payload

  const { lastFetchedAt } = yield* select(selectMemberTasksRequestState, episodeId)
  const isFresh = lastFetchedAt != null && Date.now() - lastFetchedAt < MEMBER_TASKS_STALE_TTL_MS

  if (!force && isFresh) return

  try {
    logger.info('fetchTasks started', { episodeId })
    yield* put(memberTasks.fetchTasksStarted({ episodeId }))

    const tasks = yield* call(getNextTasks, episodeId)

    yield* put(memberTasks.fetchTasksSuccess({ episodeId, tasks, fetchedAt: Date.now() }))

    logger.info('fetchTasks success', { episodeId, taskCount: tasks.length })
  } catch (error) {
    yield* put(memberTasks.fetchTasksFailure({ episodeId, error }))
    logger.error('fetchTasks failure', { episodeId }, error as Error)
  }
}

// Prevents the previous member's tasks from leaking into the next session.
export function* resetMemberTasks() {
  yield* put(memberTasks.reset())
}
